import BaseAPI from "./BaseAPI";
import { shiftRoute } from "../routes";
import { newIdempotencyKey } from "@/composables/globalMethods";

export default class ShiftAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, shiftRoute, "shift");
    }

    async Add(data, idempotencyKey = newIdempotencyKey()) {
        return super.Add(data, idempotencyKey);
    }

    /**
     * List shifts, optionally filtered by location
     * @param {string} [locationId] - Optional location ID to filter shifts
     * @returns {Promise<Array>} Array of shifts
     */
    async ListByLocation(locationId) {
        const query = locationId ? `?location_id=${locationId}` : "";
        return this._request("get", this._url(query));
    }
}
